var map = {
	"./en/1.png": 2333,
	"./en/10.png": 2334,
	"./en/11.png": 2335,
	"./en/12.png": 2336,
	"./en/13.png": 2337,
	"./en/2.png": 2338,
	"./en/3.png": 2339,
	"./en/4.png": 2340,
	"./en/5.png": 2341,
	"./en/6.png": 2342,
	"./en/7.png": 2343,
	"./en/8.png": 2344,
	"./en/9.png": 2345,
	"./ru/1.png": 2346,
	"./ru/10.png": 2347,
	"./ru/11.png": 2348,
	"./ru/12.png": 2349,
	"./ru/13.png": 2350,
	"./ru/2.png": 2351,
	"./ru/3.png": 2352,
	"./ru/4.png": 2353,
	"./ru/5.png": 2354,
	"./ru/6.png": 2355,
	"./ru/7.png": 2356,
	"./ru/8.png": 2357,
	"./ru/9.png": 2358
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2332;


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration ^\.\/.*$
// module id = 2332
// module chunks = 0